import { number, object, string } from "yup";
import EmploymentType from "../../common/interfaces/enums/EmploymentType";
import { IOccupationQuoteClient } from "../interfaces/form/occupation/IOccupationQuoteClient";

const client = object<IOccupationQuoteClient>({
    class: string().required("Please tell us your occupation"),
    employmentType: string<EmploymentType>()
        .default(EmploymentType.Employed)
        .required("Please select an employment type"),
    income: number()
        .positive("Please enter your income")
        .required("Please enter your income"),
    name: string().default("").required("Please tell us your occupation")
});

export default { client };
